// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__orw13","buttons":"SendReceipts_buttons__2-ywI","email":"SendReceipts_email__21sqQ","bookApptTitle":"SendReceipts_bookApptTitle__1j71O"};